<template>
  <nav class="flex px-6 bg-white shadow-lg justify-between items-center">
    <div class="flex justify-between h-20 items-center">
      <router-link
        class="flex items-center"
        to="/"
      >
        <img
          class="h-16 hidden sm:block "
          src="@/assets/logo.png"
          alt="Logo"
        />
      </router-link>
    </div>
    <button
      type="button"
      @click="handleChangeLanguage"
    >
      <img
        v-show="$i18n.locale === 'es'"
        class="h-6"
        src="@/assets/britain.png"
        alt="British Flag"
      >
      <img
        v-show="$i18n.locale === 'en'"
        class="h-6"
        src="@/assets/panama.png"
        alt="Panamanian Flag"
      >
    </button>
    <ol class="flex justify-between text-2xl">
      <li
        class="mx-2"
        :class="{ hidden: this.$store.state.isAuthenticated }"
      >
        <router-link to="/admin/login">
          {{ $t('Login') }}
        </router-link>
      </li>
      <li
        class="mx-2"
        :class="{ hidden: this.$store.state.isAuthenticated }"
      >
        <router-link to="/admin/signup">
          {{ $t('Signup') }}
        </router-link>
      </li>
      <li
        class="mx-2"
        :class="{ hidden: !this.$store.state.isAuthenticated }"
      >
        <router-link to="/admin/tables">
          {{ $t('Table Plan') }}
        </router-link>
      </li>
      <li
        class="mx-2"
        :class="{ hidden: !this.$store.state.isAuthenticated }"
      >
        <router-link to="/admin/menu">
          {{ $t('Menu') }}
        </router-link>
      </li>
      <li
        class="mx-2"
        :class="{ hidden: !this.$store.state.isAuthenticated }"
      >
        <router-link to="/admin/orders">
          {{ $t('Orders') }}
        </router-link>
      </li>
      <li
        class="mx-2"
        :class="{ hidden: !this.$store.state.isAuthenticated }"
      >
        <router-link to="/admin/account">
          {{ $t('My Account') }}
        </router-link>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'AdminNavbar',
  data() {
    return {
      open: false,
    };
  },
  methods: {
    handleChangeLanguage() {
      if (this.$i18n.locale === 'en') this.$i18n.locale = 'es';
      else if (this.$i18n.locale === 'es') this.$i18n.locale = 'en';
    },
  },
};
</script>

<style></style>
